import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { usePlatformBranding } from '@/core/platform-branding';
import { brandingSettingsService, type BrandingAssetType, type BrandingPatchBody } from '../api/branding-settings.service';

export function useBrandingSettings() {
  const client = useQueryClient();
  const { refresh } = usePlatformBranding();
  const query = useQuery({ queryKey: queryKeys.brandingSettings, queryFn: () => brandingSettingsService.get() });
  const patch = useMutation({
    mutationFn: (body: BrandingPatchBody) => brandingSettingsService.patch(body),
    onSuccess: async (data) => { client.setQueryData(queryKeys.brandingSettings, data); await refresh(); },
  });
  const upload = useMutation({
    mutationFn: ({ file, type }: { file: File; type: BrandingAssetType }) => brandingSettingsService.upload(file, type),
    onSuccess: async () => {
      await client.invalidateQueries({ queryKey: queryKeys.brandingSettings });
      await refresh();
    },
  });
  return { query, patch, upload };
}
